import request from "@/utils/request";
import requestOMS from "@/utils/oms-request";
import {CustomsPackingProblemType} from "@/model/HqPackingListModels";
export const getCustomsGroups = (groupId: string) =>
  request({
    url: `/customs-packing/group/${groupId}`,
    method: "GET",
  });

export const unpack = (id: string, data: any) =>
  request({
    url: `/hq-packing-list/${id}/customs-packing/action/unpack`,
    method: "POST",
    data,
  });

export const confirmScanning = (data: {
  hqPackingListId: string;
  ids: string[];
}) =>
  request({
    url: `/customs-packing/states`,
    method: "PUT",
    data,
  });

export const updateProductQuantity = (id: string, data: { quantity: number }) =>
  request({
    url: `/hq-packing-lists/products/${id}/quantity`,
    method: "PUT",
    data,
  });

export const deleteCustomsPacking = (id: string) =>
  request({
    url: `/hq-packing-lists/customs-packing/${id}`,
    method: "DELETE",
  });

export const updateCustomsPackingInfo = (id: string, data: any) =>
  request({
    url: `/hq-packing-lists/${id}/packages`,
    method: "PUT",
    data,
  });

export const getAllCustomsPackingProblemTypes = () =>
  request({
    url: "/customs-packing-problem-types",
    method: "GET",
  });

export const moveCustomsPackingStorageLayers = (data: {
  storageLayerId: string;
  ids: string[];
  deliveryNoteId: string;
}) =>
  request({
    url: "/customs-packing/storage-layer",
    method: "PUT",
    data,
  });

export const updateProblemCustomsPackingState = (data: {
  hqPackingListId: string;
  ids: string[];
}) =>
  request({
    url: "/problem-customs-packing/states",
    method: "PUT",
    data,
  });

export const deleteProblemCustomsPacking = (data: { ids: string[] }) =>
  request({
    url: "/problems-customs-packing",
    method: "DELETE",
    data,
  });
export const queryProductInfos = (id: string) =>
  request({
    url: `/customs-packing-set/${id}/product-infos`,
    method: "GET",
  });

export const updateSecondaryQuantity = (
  id: string,
  params: { quantity: number }
) =>
  request({
    url: `/customs-packing/secondary-packing/${id}`,
    method: "PUT",
    params,
  });

export const statisticsCustomsPackingData = (id: string): Object =>
  request({
    url: `/delivery-notes/${id}/weight-and-volume`,
    method: "GET",
  });

// 获取索赔明细信息
export const getCustomsPackingInfo = (id: string): Object =>
  requestOMS({
    url: `/hq-packing-list/${id}/claim-amount`,
    method: "GET",
  });

//装箱单总金额
export const getCustomsPackingAmount = (id: string): Object =>
  requestOMS({
    url: `/hq-packing-list/${id}/total-amount`,
    method: "GET",
  });

// 查询箱封号
// /customs-packing/product-info/container-number
export const postContainerNumber = (data) =>
  request({
    url: `/customs-packing/product-info/container-number`,
    method: "post",
    data
  });

  // /customs-packing/product-info/container-number
  // 修改箱封号
  export const putContainerNumber = (data) =>
    request({
      url: `/customs-packing/product-info/container-number`,
      method: "put",
      data
    });

  //  /customs-packing/weight
  export const putHandelWeight = (data) =>
    request({
      url: `/customs-packing/weight`,
      method: "put",
      data
    });

/**
 * 根据piInfoId查询被使用的库存产品所在的最新的主包装
 * @param piInfoId
 */
export const queryUsedPacking = (piInfoId:string, poInfoId:string ) =>
    request({
        url: `/customs-packing-set/used-by-pi?piInfoId=${piInfoId}&&poInfoId=${poInfoId}`,
        method: "get",
    });

/**
 * 查询主包装的所有异常类型。
 */
export const queryPackingExceptionReason = () =>
    request({
        url: `/customs-packing-set/problem_types`,
        method: "get",
    });

/**
 * 标记异常。
 */
export const markException = (id:string ,reason:CustomsPackingProblemType) =>
    request({
        url: `/customs-packing-set/${id}/mark?reason=${reason}`,
        method: "PUT",
    });

/**
 * 取消标记异常。
 */
export const unmarkException = (id:string) =>
    request({
        url: `/customs-packing-set/${id}/unmark`,
        method: "PUT",
    });
/**
 * 点击主包装，展示采购订单型号的单据、超欠发和全部号码。
 */
export const queryPoInfoDocAndNumbers = (id:string) =>
    request({
        url: `/customs-packing/${id}/po-infos/doc-and-numbers`,
        method: "GET",
    })